import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  loaderContainer: {
    position: 'absolute',
    right: '0%',
    top: '0%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 1,
    backdropFilter: 'blur(10px)',
  },
}));
